import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-loader',
  templateUrl: './table-loader.component.html',
  styleUrls: ['./table-loader.component.scss'],
})
export class TableLoaderComponent implements OnInit {
  constructor() {}

  @Input() columns: number = 5;
  @Input() rows: number = 3;
  @Input() headers: string[] = [];

  ngOnInit(): void {}
}
